/**
 *
 * @param {*} valDate
 * @returns string 날짜
 */
const dateToString = valDate => {
  let str = '';
  const year = valDate.getFullYear();
  const month = valDate.getMonth() + 1 > 9 ? valDate.getMonth() + 1 : `0${valDate.getMonth() + 1}`;
  const date = valDate.getDate() > 9 ? valDate.getDate() : `0${valDate.getDate()}`;

  const hh = valDate.getHours() > 9 ? valDate.getHours() : `0${valDate.getHours()}`;
  const mm = valDate.getMinutes() > 9 ? valDate.getMinutes() : `0${valDate.getMinutes()}`;

  str = `${year}-${month}-${date} ${hh}:${mm}`;
  return str;
};

export { dateToString };
